<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap"></div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加优惠券</el-button>
    </div>

    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="门店"><el-input v-model="formInline.store_name" placeholder="请输入门店名称"></el-input></el-form-item>
  

          <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        </el-form>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="coupon_id" label="优惠券ID" width="70"></el-table-column>
            <el-table-column prop="store.store_name" label="所属门店" width="100"></el-table-column>
            <el-table-column prop="coupon_type" label="优惠券类型" ></el-table-column>
            <el-table-column prop="name" label="优惠券名称"></el-table-column>
            <el-table-column prop="min_price" label="最低消费金额"></el-table-column>
            <el-table-column prop="seckill_stock" label="优惠方式">
              <template slot-scope="scope">
                <div v-if="Number(scope.row.coupon_type.value) === 10">
                  <span>立减 <strong class="orange">{{ scope.row.reduce_price }}</strong> 元</span>
                </div>
                <div v-if="Number(scope.row.coupon_type.value) === 20">
                  <span>打 <strong class="orange">{{ scope.row.discount }}</strong> 折</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="充值卡激活赠送卡余额"></el-table-column>
            <el-table-column prop="nprice" label="充值卡激活费用" ></el-table-column>

            <el-table-column prop="seckill_stock" label="有效期">
              <template slot-scope="scope">
                <div v-if="Number(scope.row.expire_type) === 10">
                  <span>领取 <strong>{{ scope.row.expire_day }}</strong> 天内有效</span>
                </div>
                <div v-if="Number(scope.row.expire_type) === 20">
                  <span>
                    {{ scope.row.start_time.text }}
                    ~
                    {{ scope.row.end_time.text }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receive_num" label="发放总数量">
              <template slot-scope="scope">
                <div v-if="Number(scope.row.total_num) === -1">
                  <span>不限制</span>
                </div>
                <div v-else>
                  <span>{{ scope.row.total_num }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="receive_num" label="已领取数量"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="添加时间" width="135"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="Number(scope.row.coupon_type.value) === 30 && Number(scope.row.state.value) === 1" @click="getQrcode(scope.row)" type="text" size="small">兑换码</el-button>
                <el-button v-if="(Number(scope.row.coupon_type.value) === 30 || Number(scope.row.coupon_type.value) === 40) && Number(scope.row.state.value) === 1" @click="genCard(scope.row)" type="text" size="small">生成</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button v-if="Number(scope.row.coupon_type.value) !== 30" @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage" :page-sizes="[12, 24, 36, 42, 48]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="genCardVisible" width="60%" :before-close="handleClose">
      <el-form ref="genCard" :model="rules" class="demo-form-inline" label-width="80px">
        <div class="common-form">卡号规则</div>
        <el-form-item label="前缀" prop="card_no.prefix">
          <el-input v-model="prefix" placeholder="卡号前缀" @keyup.native="rules.card_no.prefix=rules.card_no.prefix.replace(/[^a-zA-Z]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="生成规则" prop="card_no.suffix.type">
          <el-radio v-model="rules.card_no.suffix.type" :label="10">指定数字开始</el-radio>
          <el-radio v-model="rules.card_no.suffix.type" :label="20">数字区间</el-radio>
        </el-form-item>
        <div v-if="Number(rules.card_no.suffix.type) === 10">
          <el-form-item label="开始数值" prop="card_no.suffix.value">
            <el-input-number v-model="rules.card_no.suffix.value" :min="1000" :max="10000000" label="卡号开始数值"></el-input-number>
          </el-form-item>
          <el-form-item label="生成数量" prop="card_no.suffix.num">
            <el-input-number v-model="rules.card_no.suffix.num" :min="1" :max="999999" label="生成数量"></el-input-number>
          </el-form-item>
        </div>
        <el-form-item label="区间" v-else>
          <el-col :span="8">
            <el-input-number v-model="rules.card_no.suffix.start" :min="1000" :max="99999999" label="卡号开始数值"></el-input-number>
          </el-col>
          <el-col class="line" :span="4"><i class="el-icon-minus"/></el-col>
          <el-col :span="12">
            <el-input-number v-model="rules.card_no.suffix.end" :min="1001" :max="100000000" label="卡号结束数值"></el-input-number>
          </el-col>
        </el-form-item>
        <div class="common-form">密码规则</div>
        <el-form-item label="密码长度" prop="pwd.length">
          <el-input-number v-model="rules.pwd.length" :min="5" :max="8" label="生成密码长度"></el-input-number>
        </el-form-item>

        <!-- <div class="common-form">卡金额</div>
        <el-form-item label="金额" prop="price">
          <el-input-number v-model="rules.price" type="number" label="卡金额"></el-input-number>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" :loading="genCardLoading">取 消</el-button>
        <el-button type="primary" @click="behindGenCard" :loading="genCardLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="兑换二维码" :visible.sync="qrcodeVisible" width="60%" :before-close="handleClose">
      <img :src="qrcode_url" alt="exchange_bg">
    </el-dialog>
  </div>
</template>
<script>
import CouponApi from '@/api/coupon.js';
import DataApi from '@/api/data.js';

export default {
  data() {
    return {
      formInline: {
        store_name:""
      },
      form: {},
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否加载完成*/
      loading: true,
      // 生成规则
      rules: {
        coupon_id: 0,
        card_no: {
          prefix: '',
          suffix: {
            type: 10,
            value: 10000,
            num: 3,
            start: 10000,
            end: 10005,
          },
        },
        pwd: {
          length: 6
        },
        price:0,
      },
      // 生成规则弹窗
      genCardVisible: false,
      genCardLoading: false,
      qrcodeVisible:false,
      qrcode_url:''
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  computed: {
    prefix: {
      get: function () {
        return this.rules.card_no.prefix;
      },
      set: function (val) {
        this.rules.card_no.prefix = val.toUpperCase();
      }
    }
  },
  methods: {
    onSubmit() {
        let self = this;
        self.loading = true;
        self.getData();
      },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      CouponApi.couponList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total
        })
        .catch(error => {});
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*添加优惠券*/
    addClick() {
      this.$router.push('/plus/coupon/coupon/add');
    },
    /*修改优惠券*/
    editClick(e) {
      this.$router.push({
        path: '/plus/coupon/coupon/edit',
        query: {
          coupon_id: e.coupon_id
        }
      })
    },
    /*删除优惠券*/
    deleteClick(e) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        CouponApi.deleteCoupon({
          coupon_id: e.coupon_id
        }, true).then(data => {
          self.loading = false;
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.getData();

        })
          .catch(error => {
            self.loading = false;
          });

      }).catch(() => {
        self.loading = false;
      });
    },
    behindGenCard() {
      // 主要是验证区间，大小
      if (Number(this.rules.card_no.suffix.type) === 20) {
        if (this.rules.card_no.suffix.start >= this.rules.card_no.suffix.end) {
          this.$message.error('开始区间不能比结束区间小')
          return false
        }
      }
      let self = this;
      self.genCardLoading = true
      self.$confirm('批量生成礼品卡, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CouponApi.genCard(self.rules, true)
          .then(data => {
            if (Number(data.code) === 1) {
              self.$message({
                message: '操作成功,后台处理中,请稍后查看',
                type: 'success'
              });
              self.handleClose()
              //刷新页面
              self.getTableList();
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
            self.genCardLoading = false
          }).catch(error => {})
      }).catch(() => {
        self.genCardLoading = false
      })
    },
    /* 一键生成提货卡 */
    genCard(row) {
      this.rules.coupon_id = row.coupon_id
      this.genCardVisible = true
    },
    getQrcode(row) {
      let params = {
        app_id:row.app_id,
        source:'wx',
        type:'coupon_pick_up',
        coupon_id:row.coupon_id,
      };
      DataApi.getQrcode(params,true)
      .then(res=>{
        this.qrcode_url = res.data.qrcode
        this.qrcodeVisible = true
      }).catch(error => {})
      // this.rules.coupon_id = row.coupon_id
      
    },
    handleClose() {
      this.qrcodeVisible = false
      this.$refs['genCard'].resetFields()
      this.genCardVisible = false
      this.genCardLoading = false
      
    },

  }
};
</script>

<style lang="scss" scoped>
.demo-form-inline .line {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/index.vue